<div class="income-predictor-verification">
    <div class="form-group">
      <label for="id_number" class="fw-bold text-xs">ID Number</label>
      <input type="text" v-model="form.id_number" id="id_number" class="form-control text-xs rounded-small p-3 shadow-sm" required />
      <small v-if="error_messages.id_number" class="form-text text-danger text-xs fw-bold">
        {{ error_messages.id_number }}
      </small>
    </div>
    <div class="d-flex justify-content-end my-2">
        <button @click="handle_submit" class="btn btn-primary-color rounded-pill text-xs">
            Run Service
        </button>
    </div>
</div>
